import { Paper, Typography } from "@mui/material";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

export default function ChartArea({ title, data }) {
    return (
        <Paper sx={{ p: 3, borderRadius: 3, height: 320 }}>
            <Typography variant="h6" sx={{ mb: 2 }}>
                {title}
            </Typography>

            <ResponsiveContainer width="100%" height="85%">
                <AreaChart data={data}>
                    <defs>
                        <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#1c64f2" stopOpacity={0.4} />
                            <stop offset="75%" stopColor="#1c64f2" stopOpacity={0.05} />
                        </linearGradient>
                    </defs>

                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                    <Tooltip />
                    <Area
                        type="monotone"
                        dataKey="valor"
                        stroke="#1c64f2"
                        fill="url(#color)"
                        strokeWidth={3}
                    />
                </AreaChart>
            </ResponsiveContainer>
        </Paper>
    );
}
